import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Device } from '@capacitor/device';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { AlertController } from '@ionic/angular/standalone';
import { Filesystem } from '@capacitor/filesystem';
import { TakePhotoService } from './take-photo.service';
import { GeolocationService } from './geolocation.service';
import { NetworkService } from './network.service';
import { LoadingService } from './loading.service';

@Injectable({
    providedIn: 'root',
})
export class AppInfoService
{
    private loadingService = inject(LoadingService);
    private networkService = inject(NetworkService);
    private geolocationService = inject(GeolocationService);
    private takePhotoService = inject(TakePhotoService);
    private alertController = inject(AlertController);

    async getAppInfo(): Promise<string>
    {
        const deviceInfo = await Device.getInfo();
        console.info('await Device.getInfo()', deviceInfo);

        let appInfoString = Capacitor.getPlatform();

        if (Capacitor.isNativePlatform())
        {
            const appInfo = await App.getInfo();
            console.info('await App.getInfo()', appInfo);

            appInfoString += ` | ${appInfo.version}`;
        }
        else
        {
            appInfoString += ` | ${environment.version}`;
        }

        appInfoString += ` | ${deviceInfo.webViewVersion}`;

        console.info(appInfoString);

        return appInfoString;
    }

    async showAppInfo()
    {
        const deviceInfo = await Device.getInfo();

        let message = `<div>Platform: <b>${Capacitor.getPlatform()}</b></div>`;

        if (Capacitor.isNativePlatform())
        {
            const appInfo = await App.getInfo();
            message += `<div>App Version: <b>${appInfo.version}</b></div>`;
        }
        else
        {
            message += `<div>App Version: <b>${environment.version}</b></div>`;
        }

        message += `<div>Webview Version: <b>${deviceInfo.webViewVersion}</b></div>`;
        message += `<div>OS Version: <b>${deviceInfo.osVersion}</b></div>`;
        message += `<div>Device Model: <b>${deviceInfo.model}</b></div>`;
        message += await this.takePhotoService.getCameraPermissionsMessage();
        message += await this.geolocationService.getGeolocationPermissionsMessage();
        message += await this.getFileSystemPermissionsMessage();

        console.info('showAppInfo alert message', message);
        const appInfo = await this.getAppInfo();

        const alert = await this.alertController.create({
            backdropDismiss: true,
            animated: true,
            message,
            header: 'App Info',
            subHeader: appInfo,
            buttons: [
                {
                    text: 'OK',
                    role: 'confirm',
                },
            ],
        });
        await alert.present();
    }

    private async getFileSystemPermissionsMessage(): Promise<string>
    {
        try
        {
            const permissionStatus = await Filesystem.checkPermissions();
            console.info('await Filesystem.checkPermissions()', permissionStatus);

            let message = `<div>FileSystem Permissions:</div><ul class="m-0">`;
            message += `<li>Public Storage: <b>${permissionStatus.publicStorage}</b></li>`;
            message += `</ul>`;

            return message;
        }
        catch (error: any)
        {
            console.error('getFileSystemPermissionsMessage()', error);

            let message = `<div>FileSystem Permissions:</div><ul class="m-0">`;
            message += `<li>Public Storage: <b>not able to check permissions</b></li>`;
            message += `</ul>`;

            return message;
        }
    }
}
